import httpService from "./httpService";

export const search = async (params: any) => {
	const { data } = await httpService.get(`/ages/search/`, { params });
	return data;
};

export const getAges = async () => {
	const { data } = await httpService.get(`/ages/systems/`);
	return data;
};
